import { render } from "./weddinganniversaryReport.vue?vue&type=template&id=da4e8658&scoped=true"
import script from "./weddinganniversaryReport.vue?vue&type=script&lang=js"
export * from "./weddinganniversaryReport.vue?vue&type=script&lang=js"

import "./weddinganniversaryReport.vue?vue&type=style&index=0&id=da4e8658&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4e8658"]])

export default __exports__